import { createContext, useContext } from "react";

// Localisation visiteur DÉSACTIVÉE sur le site public (à la demande).
// Le dashboard admin continue d'enregistrer la ville via le backend indépendamment.
const LocationContext = createContext({ city: "", postal: "", source: "", ready: true });

export const LocationProvider = ({ children }) => (
    <LocationContext.Provider value={{ city: "", postal: "", source: "", ready: true }}>
        {children}
    </LocationContext.Provider>
);

export const useCity = () => useContext(LocationContext);
